import React from "react"
import { useSelector } from "react-redux"

import { StoreType } from "client/store"
import { ChevronLeftIcon, ChevronRightIcon } from "client/components"
import {
    PaginationWrapper,
    PageButton,
    PrevNextButton,
} from "./styled"


export interface PaginationProps {
    curPage: number
    numberOfPages: number
    onClickPrevPage: () => void
    onClickNextPage: () => void
    onClickPage: (page: number) => void
}

export const Pagination = ({
    curPage,
    numberOfPages,
    onClickPrevPage,
    onClickNextPage,
    onClickPage,
}: PaginationProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const sidePages = 3

    let firstPage = curPage - sidePages
    let lastPage = curPage + sidePages

    if (firstPage <= 0) {
        firstPage = 1
        lastPage = sidePages * 2 + 1
        lastPage = (lastPage > numberOfPages) ? numberOfPages : lastPage
    }
    if (lastPage > numberOfPages) {
        lastPage = numberOfPages
        firstPage = numberOfPages - sidePages * 2
        firstPage = (firstPage > 0) ? firstPage : 1
    }

    const pages: number[] = []
    for (let page = firstPage; page <= lastPage; page++) {
        pages.push(page)
    }

    return (
        <PaginationWrapper>
            <PrevNextButton
                isActive={curPage !== 1}
                onClick={onClickPrevPage}
            >
                <ChevronLeftIcon />
                {lang.prevPage}
            </PrevNextButton>
            {
                pages.map((page) => (
                    <PageButton
                        key={page}
                        isActive={page === curPage}
                        onClick={() => onClickPage(page)}
                    >
                        {page}
                    </PageButton>
                ))
            }
            <PrevNextButton
                isActive={curPage !== numberOfPages}
                onClick={onClickNextPage}
            >
                {lang.nextPage}
                <ChevronRightIcon />
            </PrevNextButton>
        </PaginationWrapper>
    )
}
